import React, { useState } from "react";
import {
    Box,
    Card,
    CardBody,
    Heading,
    FormControl,
    FormLabel,
    Select,
    Input,
    Textarea,
    Button,
    Text,
    VStack,
    useToast,
    useTheme,
} from "@chakra-ui/react";
import getAxios from "../../hooks/useAxios";
import { Theme } from "../../theme";
import Cookies from "js-cookie";

const NotificationForm: React.FC = () => {
    const toast = useToast();
    const theme = useTheme<Theme>();
    const axios = getAxios();
    const access_token = Cookies.get("x-admin-auth");
    const [recipientType, setRecipientType] = useState("");
    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!recipientType || !title || !body) {
            toast({
                title: "All fields are required",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        try {
            setLoading(true);
            const data = {
                recipient_type: recipientType,
                title: title,
                body: body
            }
            console.log("data", data);
            await axios.post("/notifications", data, {
                headers: {
                    Authorization: `Bearer ${access_token}`,
                },
            })
            toast({
                title: "Notification Sent",
                status: "success",
                duration: 3000,
                isClosable: true,
            });
            setRecipientType("");
            setTitle("");
            setBody("");
        } catch (error) {
            console.log("error sending notification", error);
            toast({
                title: "Something went wrong",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box p={6} maxW="600px" mx="auto">
            <Card shadow="lg" borderRadius="xl">
                <CardBody>
                    <Heading size="md" mb={6}>
                        Send Notification
                    </Heading>

                    <VStack spacing={5} align="stretch">
                        <FormControl isRequired>
                            <FormLabel>Recipient Type</FormLabel>
                            <Select
                                placeholder="Select recipient"
                                value={recipientType}
                                onChange={(e) => setRecipientType(e.target.value)}
                            >
                                <option value="rider">Rider</option>
                                <option value="driver">Driver</option>
                            </Select>
                        </FormControl>

                        <FormControl isRequired>
                            <FormLabel>Title</FormLabel>
                            <Input
                                placeholder="Enter notification title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </FormControl>

                        <FormControl isRequired>
                            <FormLabel>Body</FormLabel>
                            <Textarea
                                placeholder="Enter notification message"
                                value={body}
                                onChange={(e) => setBody(e.target.value)}
                                rows={4}
                            />
                        </FormControl>

                        <Button
                            height="3rem"
                            style={{
                                background: theme.colors.primary.main,
                                color: theme.colors.bg.main,
                            }}
                            onClick={handleSubmit}
                            isLoading={loading}
                            loadingText="Sending..."
                        >
                            <Text sx={{ fontSize: theme.fontSizes.body }}>Send</Text>
                        </Button>
                    </VStack>
                </CardBody>
            </Card>
        </Box>
    );
};

export default NotificationForm;